import classNames from "classnames";
import { WatchListPageNav } from "components/WatchLive/WatchListPageNav";
import { MediaQuery } from "@outplayed/responsive";
import { useState } from "react";
// import { ReactComponent as FilterIcon } from "@ugg/shared/assets/svg/filters-icon.svg";
// import { ReactComponent as SearchIcon } from "@ugg/shared/assets/svg/search-icon.svg";
// import { ReactComponent as BackButton } from "@ugg/shared/assets/svg/undo-button.svg";
import { StreamContainer } from "./StreamContainer";
import dark404Img from "@ugg/shared/assets/images/404-dark.png";
import { getTwitchStreams } from "@ugg/shared/api/requests/allstar/watch-twitch";
import WatchStreamSelector from "./WatchStreamSelector";
import WatchGameSwitcher from "./WatchGameSwitcher";
import { WatchGameFilterManager } from "./WatchGameFilterManager";
import { SvgGameWow } from "@ugitgud/legos/ui/icon/SVG/GameWow";
import { SvgGameLol } from "@ugitgud/legos/ui/icon/SVG/GameLol";
import { SvgGameTft } from "@ugitgud/legos/ui/icon/SVG/GameTft";
import { SvgGameVal } from "@ugitgud/legos/ui/icon/SVG/GameVal";
import { SvgGameDeadlock } from "@ugitgud/legos/ui/icon/SVG/GameDeadlock";
import { SvgGameHelldivers } from "@ugitgud/legos/ui/icon/SVG/GameHelldivers";
import { SvgGameRematch } from "@ugitgud/legos/ui/icon/SVG/GameRematch";

export function WatchList({ className }: { className?: string }) {
  const [currentGame, setCurrentGame] = useState("lol");
  const listOfGames = {
    lol: "League of Legends",
    wow: "World of Warcraft",
    tft: "Team Fight Tactics",
    val: "Valorant",
    deadlock: "Deadlock",
    hd2: "Helldivers 2",
    rematch: "Rematch",
  };

  const listOfGamesTest = [
    {
      value: "lol",
      label: "League of Legends",
      img: <SvgGameLol />,
    },
    {
      value: "tft",
      label: "Team Fight Tactics",
      img: <SvgGameTft />,
    },
    {
      value: "wow",
      label: "World of Warcraft",
      img: <SvgGameWow />,
    },
    {
      value: "val",
      label: "Valorant",
      img: <SvgGameVal />,
    },
    {
      value: "deadlock",
      label: "Deadlock",
      img: <SvgGameDeadlock />,
    },
    {
      value: "hd2",
      label: "Helldivers 2",
      img: <SvgGameHelldivers />,
    },
    {
      value: "rematch",
      label: "Rematch",
      img: <SvgGameRematch />,
    },
  ];

  const onFilterChange = (type: any, value: any) => {
    setCurrentGame(value.value);
  };

  const { data, error, loading } = getTwitchStreams(currentGame);

  // const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
  //   setInput(e.target.value);
  // };
  // const [input, setInput] = useState("");

  const hasFeaturedData = data?.featuredStreams;

  interface StreamInformation {
    streamName: string;
    streamImage: string;
    streamTitle: string;
    streamChannel: string;
  }

  const [selectedStream, setSelectedStream] = useState<StreamInformation>({
    streamName: "",
    streamImage: "",
    streamTitle: "",
    streamChannel: "",
  });

  // On click of a Stream Thumbnail it will load all the data into a stream info interface
  // and update the set state funciton causing a refresh and that refresh will conitionaly
  // render the Stream Container.
  const handleStreamSelection = (
    newStreamImage: string,
    newStreamName: string,
    newStreamTitle: string,
    newStreamChannel: string,
  ) => {
    const newStreamInfo: StreamInformation = {
      streamName: newStreamName,
      streamImage: newStreamImage,
      streamTitle: newStreamTitle,
      streamChannel: newStreamChannel,
    };
    window.scrollTo({
      top: 0,
      left: 0,
    });
    setSelectedStream(newStreamInfo);
  };

  const clearStreamSelection = () => {
    const newStreamInfo: StreamInformation = {
      streamName: "",
      streamImage: "",
      streamTitle: "",
      streamChannel: "",
    };
    setSelectedStream(newStreamInfo);
  };

  const isStreamSelectionEmpty =
    selectedStream.streamName == "" &&
    selectedStream.streamImage == "" &&
    selectedStream.streamChannel == "" &&
    selectedStream.streamTitle == ""
      ? true
      : false;

  const gameName = listOfGames[currentGame as keyof typeof listOfGames];

  return (
    <div className={classNames(className)}>
      {!isStreamSelectionEmpty ? (
        <StreamContainer
          streamImage={selectedStream.streamImage}
          streamChannel={selectedStream.streamChannel}
          streamName={selectedStream.streamName}
          streamTitle={selectedStream.streamTitle}
          handleClick={() => clearStreamSelection()}
        ></StreamContainer>
      ) : (
        <div>
          <div>
            <h1 className="flex items-center whitespace-nowrap max-sm:flex-col max-sm:items-start font-['Barlow'] pt-[36px] pb-[30px]">
              <span className="mr-[12px] text-[36px] font-semibold max-sm:text-[28px] max-sm:w-full max-sm:truncate">{`Watch`}</span>
              <span className="text-[36px] font-normal text-lavender-50 max-sm:truncate max-sm:w-full max-sm:text-[28px] max-xs:text-[24px]">
                {`Streamers & Highlights`}
              </span>
            </h1>
            <div className="flex font-medium text-[16px] leading-[19px] text-[#CDDCFE] font-inter pb-[25px]">
              Discover and watch your favorite streamers live or catch up on popular highlights
            </div>
            {/* <div className="pb-[30px]">
              <WatchListPageNav></WatchListPageNav>
            </div> */}
            <WatchGameFilterManager
              isDefault={false}
              currentGame={currentGame}
              onFilterChange={onFilterChange}
              listOfGamesTest={listOfGamesTest}
              disableTooltip
              disableByQueueType
            />
          </div>
          <div className="watch-main-content">
            {hasFeaturedData ? (
              <div className="content-section featured-streams">
                <div className="content-section_header">Featured Streams</div>
                <div className="stream-selector-container">
                  {data?.twitchStreams
                    .slice(0, 4)
                    .map(
                      (index: {
                        thumbnailUrl: string;
                        title: string;
                        userName: string;
                        viewerCount: number;
                        userLogin: string;
                      }) => (
                        <WatchStreamSelector
                          className="stream-selectable"
                          thumbnail={index.thumbnailUrl}
                          stream_title={index.title}
                          streamer_name={index.userName}
                          streamer_icon="N/A"
                          view_count={index.viewerCount}
                          handleClick={() => handleStreamSelection("test", index.userName, index.title, index.userLogin)}
                        ></WatchStreamSelector>
                      ),
                    )}
                </div>
              </div>
            ) : null}
            <div className="content-section main-content-streams">
              <div className="content-section_header">{gameName}</div>
              <div className="stream-selector-container">
                {data && loading !== true ? (
                  data?.twitchStreams.slice(0, 16).map(
                    (
                      stream: {
                        thumbnailUrl: string;
                        title: string;
                        userName: string;
                        viewerCount: number;
                        userLogin: string;
                        profileImageUrl: string;
                      },
                      index: number,
                    ) => (
                      <div key={index}>
                        <WatchStreamSelector
                          className="stream-selectable"
                          thumbnail={stream.thumbnailUrl}
                          stream_title={stream.title}
                          streamer_name={stream.userName}
                          streamer_icon={stream.profileImageUrl}
                          view_count={stream.viewerCount}
                          handleClick={() =>
                            handleStreamSelection(stream.profileImageUrl, stream.userName, stream.title, stream.userLogin)
                          }
                        ></WatchStreamSelector>
                      </div>
                    ),
                  )
                ) : (
                  <div className="flex-1 basis-[400px]">
                    <img className="mx-auto w-full max-w-[500px]" src={dark404Img} alt="404" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
